// =====================================================================
// Configuração central do PORTAL DO ESTUDANTE (UEB).
//
// Isolado do validador antigo de propósito: por enquanto o portal é um
// app novo dentro do mesmo projeto. baseURL, chaves e constantes vivem
// aqui pra ficar fácil de apontar pra homologação/produção depois.
// =====================================================================

// ---- Backend (ambientes) ----
// Mesmo backend do validador (uebServer). Pra trocar o portal INTEIRO
// entre produção / homologação / local, mude só a linha do AMBIENTE abaixo.
const AMBIENTES = {
    local: 'http://localhost:3025',
    homolog: '', // TODO: preencher com a URL do backend de homologação quando existir
    producao: 'https://funemysql-ueb-server.alehbv.easypanel.host',
};

// >>> Único lugar pra apontar produção/homologação/local. <<<
// (também respeita REACT_APP_AMBIENTE se um dia houver .env)
const AMBIENTE = process.env.REACT_APP_AMBIENTE || 'local';

// currentServer TEM que ser igual à baseURL do axios (o interceptor de
// token casa por isso). Se o ambiente escolhido estiver vazio, cai em produção.
export const currentServer = 'https://funemysql-ueb-server.alehbv.easypanel.host';

// Mantidos por compatibilidade com quem já importava LOCAL/HOST.
const LOCAL = AMBIENTES.local;
const HOST = AMBIENTES.producao;
export { LOCAL, HOST, AMBIENTE, AMBIENTES };

// ---- URLs externas / públicas ----
// Ficam aqui (não chumbadas nos componentes) pra trocar num lugar só.

// Consulta de CEP -> endereço (ViaCEP). Público, sem chave, igual em todo
// ambiente. Usado por buscarEnderecoPorCepApi em api/index.js.
export const VIACEP_URL = 'https://viacep.com.br/ws';

// Domínio público do validador da carteirinha (vai no QR/link impresso).
// Pode mudar entre produção e homologação — por isso mora aqui.
export const VALIDADOR_PUBLICO_URL =
    process.env.REACT_APP_VALIDADOR_URL || 'https://www.uebcarteirinha.com.br';

// Monta o link de validação que vai no QR da carteirinha.
export const montarUrlValidacao = (cpf, codigoUso) =>
    `${VALIDADOR_PUBLICO_URL}/validador/${String(cpf || '').replace(/\D/g, '')}/${codigoUso}`;

// Links externos estáticos (mesmos em qualquer ambiente).
export const CORREIOS_RASTREIO_URL = 'https://rastreamento.correios.com.br/app/index.php';
export const GOV_VALIDAR_URL = 'https://validar.iti.gov.br/';

// ---- App do estudante (lojas) ----
// PREENCHER com as URLs do app UEB. Vazio = o botão fica visível mas não abre
// nada (seguro até você colar as URLs reais).
export const APP_STORE_URL =
    process.env.REACT_APP_APP_STORE_URL || 'https://apps.apple.com/br/app/ueb-carteirinha-de-estudante/id6755449524'; // ex.: https://apps.apple.com/br/app/.../idXXXXXXXX
export const PLAY_STORE_URL =
    process.env.REACT_APP_PLAY_STORE_URL || 'https://play.google.com/store/apps/details?id=com.linstef.uebcarteirinha&hl=pt_BR'; // ex.: https://play.google.com/store/apps/details?id=com.ueb.xxx

// ---- FUNEMG EAD (parceria) ----
// Site do EAD da FUNEMG, onde o aluno matriculado assiste às aulas. PREENCHER
// com a URL real do portal do EAD (vazio = o botão fica desativado).
export const FUNEMG_EAD_URL =
    process.env.REACT_APP_FUNEMG_EAD_URL || 'https://funemg.com.br/';

// Pagamento (Pix) é 100% server-side via Pagar.me — não há chave pública nem
// SDK de pagamento no front. Segredos ficam só no backend.

// ---- Contato ----
export const WHATSAPP_SUPORTE =
    process.env.REACT_APP_WHATSAPP_SUPORTE || '553196092454';

export const EMAIL_SUPORTE =
    process.env.REACT_APP_EMAIL_SUPORTE || 'contato@uebcarteirinha.com.br';

export const abrirWhatsappSuporte = () => {
    window.open(`https://wa.me/${WHATSAPP_SUPORTE}`, '_blank');
};

// ---- reCAPTCHA (validação pública) ----
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';
